import PageContainer from "../components/PageContainer";
import { Helmet } from 'react-helmet-async';

const PartnerUserTermsAndConditions = () => {
    return (
        <PageContainer items="center" px="4">
            <Helmet>
                <title>Condizioni per i partner - TicinoWild</title>
                <meta name="description" content="Condizioni generali per i partner fornitori di TicinoWild: iscrizione, commissioni, prenotazioni, pagamenti e obblighi del partner." />
                <link rel="canonical" href="https://ticinowild.ch/partner-terms-and-conditions" />
                <meta property="og:title" content="Condizioni per i partner - TicinoWild" />
                <meta property="og:description" content="Condizioni generali per i partner fornitori di TicinoWild: iscrizione, commissioni, prenotazioni, pagamenti e obblighi del partner." />
                <meta property="og:url" content="https://ticinowild.ch/partner-terms-and-conditions" />
                <meta name="twitter:title" content="Condizioni per i partner - TicinoWild" />
                <meta name="twitter:description" content="Condizioni generali per i partner fornitori di TicinoWild: iscrizione, commissioni, prenotazioni, pagamenti e obblighi del partner." />
            </Helmet>
            <div className="flex flex-col gap-8 max-w-[600px] mt-8 terms">
                <h3 className="font-normal">Condizioni Generali per i Fornitori di TicinoWild (CGF)</h3>
                <p>
                    Le presenti condizioni generali (di seguito “CGF”) regolano la partecipazione dei Partner (denominati
                    anche “Partner fornitori”, “Fornitori esterni” o “Fornitori di terze parti”) alla piattaforma TicinoWild.
                </p>
                <p>
                    L’inserimento di attività sulla piattaforma di TicinoWild da parte dei Partner (registrazione alla
                    piattaforma come Partner) implica l’accettazione delle presenti CGF.
                </p>
                <div>
                    <h4 className="text-[#225424]">1. Informazioni Generali</h4>
                    <p>
                        TicinoWild è una piattaforma di informazione accessibile sul sito web www.ticinowild.ch, la quale
                        offre una panoramica di attività outdoor, sia gratuite sia a pagamento, da fare in Ticino pensate per
                        diverse fasce di utenti. TicinoWild è al contempo una piattaforma di intermediazione e prenotazione e
                        serve a intermediare l’acquisto di servizi nel settore del tempo libero e dello sport, mediante
                        l'elaborazione automatizzata del processo di pagamento.
                    </p>
                    <p>
                        TicinoWild consente agli utenti di prenotare attività outdoor offerte da Partner fornitori, fungendo da
                        intermediario tra utenti e fornitori e facilitando il processo di prenotazione e pagamento dei servizi nel
                        settore del tempo libero e dello sport per conto dei propri partner.
                    </p>
                </div>




                <div>
                    <h4 className="text-[#225424]">2. Ruolo di TicinoWild</h4>
                    <p>
                        TicinoWild agisce esclusivamente come intermediario per le prenotazioni di servizi offerti dai Fornitori
                        di terze parti, facilitando la promozione e la vendita di tali attività agli utenti. Il contratto per la
                        prenotazione viene stipulato direttamente tra l'utente e il Partner fornitore, senza che TicinoWild
                        diventi parte del contratto di vendita o sia responsabile per la sua esecuzione.
                    </p>
                    <p>
                        TicinoWild declina ogni responsabilità per atti, omissioni, errori o altre azioni del Fornitore esterno e
                        non è responsabile per eventuali danni, lesioni o costi sostenuti dall’utente in relazione alle attività del
                        Partner fornitore.
                    </p>
                </div>


                <div>
                    <h4 className="text-[#225424]">3. Ambito di utilizzo dei Servizi dei Partner</h4>
                    <p>
                        Il Partner fornitore conferma e garantisce: (a) di disporre dell’autorità di vincolare legalmente l’impresa
                        che rappresenta e di concedere a TicinoWild tutti i permessi e le licenze previsti nelle presenti CGF; e
                        (b) che né la sottoscrizione né l'adempimento del presente accordo violeranno o entreranno in
                        conflitto in alcun modo con qualsiasi altro accordo eventualmente vincolante per il Fornitore esterno
                        o l’impresa che rappresenta.
                    </p>
                    <p>
                        Il Partner si assume la completa responsabilità dell'adempimento del presente accordo da parte sua e
                        dei suoi collaboratori, garantendo che ciascuno di essi sia vincolato e rispetti tutti gli obblighi e i
                        requisiti previsti dal presente accordo.
                    </p>
                </div>




                <div>
                    <h4 className="text-[#225424]">4. Iscrizione e costi</h4>
                    <h4 className="text-[#225424]">4.1 Commissione</h4>
                    <p>
                        L'inserimento di attività su TicinoWild (iscrizione come Partner alla piattaforma) è gratuito e non
                        prevede alcun costo fisso o abbonamento. Inserendo le proprie attività sul sito web di TicinoWild, i
                        Partner autorizzano TicinoWild a trattenere una commissione del 15% su ogni prenotazione ricevuta
                        attraverso la piattaforma. Non sono previsti altri costi o spese aggiuntive per i Partner.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">5. Pagamento della quota ai Partner</h4>
                    <p>
                        Per la gestione dei pagamenti TicinoWild utilizza Stripe. Maggiori informazioni sulla gestione delle
                        transazioni, nonché sulla privacy policy di Stripe e sulla gestione dei cookie da parte del loro sito web
                        è disponibile su www.stripe.com.
                    </p>
                    <p>
                        La parte destinata al Partner fornitore, pari all’85% del prezzo dell'attività, verrà versata ad ogni
                        prenotazione (confermata e pagata dall’utente) sul conto bancario indicato dal fornitore durante il
                        processo attivazione del proprio account aziendale. È responsabilità del Partner fornire e mantenere
                        aggiornate informazioni bancarie accurate per garantire il corretto accredito dei pagamenti.
                    </p>
                    <p>
                        Dopo aver richiesto l’inserimento della prima attività su TicinoWild, il Partner riceverà un link per
                        registrare i propri dati di pagamento su Stripe. Il completamento di questa procedura (attivazione
                        dell’account aziendale) è indispensabile per ricevere i pagamenti.
                    </p>
                    <p>
                        TicinoWild non applica alcuna commissione ai Partner per i pagamenti online e si assume i costi
                        relativi all’utilizzo di Stripe. Eventuali costi aggiuntivi, come commissioni bancarie o costi legati alla
                        valuta del conto del Partner, rimangono a carico del Partner stesso.
                    </p>
                    <p>
                        TicinoWild si riserva il diritto di modificare la percentuale della commissione trattenuta (commissione
                        di utilizzo della piattaforma) in qualsiasi momento, fornendo al Fornitore esterno un adeguato
                        preavviso in merito a tali modifiche prima della loro entrata in vigore. Le modifiche alle commissioni
                        non avranno effetto sulle prenotazioni effettuate prima della data di entrata in vigore della modifica
                        stessa.
                    </p>
                    <p>
                        In caso di modifica della percentuale di commissione trattenuta, il Partner ha il diritto di recedere
                        dalla collaborazione con TicinoWild prima della data di entrata in vigore delle modifiche. Se il Partner
                        non esercita tale diritto e continua a utilizzare la piattaforma per offrire i propri servizi dopo l’entrata in
                        vigore delle modifiche, tale comportamento sarà considerato come accettazione implicita delle
                        modifiche stesse.
                    </p>
                </div>



                <div>
                    <h4 className="text-[#225424]">4.3. Limitazione di responsabilità sui dati di pagamento</h4>
                    <p>
                        TicinoWild non ha accesso diretto ai dati del conto forniti dai Partner per la ricezione dei pagamenti.
                        Tutte le transazioni vengono gestite esclusivamente tramite Stripe, una piattaforma di pagamento
                        sicura e certificata, progettata per garantire la massima protezione dei dati sensibili.
                    </p>
                    <p>
                        Di conseguenza, TicinoWild declina ogni responsabilità per eventuali furti o violazioni relativi ai conti
                        dei Partner utilizzati per ricevere i pagamenti. Eventuali problematiche, come utilizzi non autorizzati o
                        controversie, dovranno essere risolte direttamente tra il Partner, il gestore del proprio e Stripe.
                    </p>
                </div>


                <div>
                    <h4 className="text-[#225424]">5. Flessibilità nelle offerte</h4>
                    <p>
                        I Partner mantengono pieno controllo sui prezzi, sulle politiche di cancellazione e sulle caratteristiche
                        delle loro offerte. TicinoWild non interferirà con queste decisioni, purché siano chiaramente
                        comunicate all’utente in fase di conferma della prenotazione dell’attività.
                    </p>
                </div>


                <div>
                    <h4 className="text-[#225424]">6. Garanzia di parità di prezzo</h4>
                    <p>
                        I Partner che collaborano con TicinoWild si impegnano a mantenere per le attività offerte sulla
                        piattaforma lo stesso prezzo applicato abitualmente ai propri clienti o pubblicato sul proprio sito web
                        ufficiale. Non è consentito ai Partner applicare maggiorazioni di prezzo per le attività prenotate tramite
                        TicinoWild.
                    </p>
                    <p>
                        TicinoWild si riserva il diritto di monitorare e verificare la conformità a questa condizione, al fine di
                        garantire la trasparenza e la tutela degli utenti. Eventuali violazioni potranno comportare l’esclusione
                        del Partner dalla piattaforma.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">7. Prenotazioni e Conferme</h4>
                    <p>
                        La piattaforma di TicinoWild consente di prenotare attività fino a 48h prima del loro svolgimento. Dopo
                        aver completato la prenotazione di un’attività sul sito web di TicinoWild, l’utente riceve una conferma
                        di ricezione della richiesta di prenotazione. Tale conferma di ricezione della richiesta di prenotazione
                        non costituisce una conferma definitiva della prenotazione.
                    </p>
                    <p>
                        Il Partner esterno riceverà anch’esso una e-mail con la richiesta di prenotazione, tramite cui può
                        confermare la richiesta o rifiutarla. In caso di conferma, l’utente riceverà una e-mail di conferma della
                        prenotazione con i dettagli del Partner responsabile dell’offerta e le istruzioni per effettuare il
                        pagamento.
                    </p>
                    <p>
                        L’Utente è tenuto a saldare l’attività prima del suo svolgimento. Una volta ricevuto il pagamento, il
                        Partner sarà informato tramite e-mail con i dettagli dell’utente e avrà 48h di tempo per contattarlo (via
                        e-mail o telefonicamente) e fornire tutte le informazioni necessarie allo svolgimento dell’attività (come
                        il luogo di ritrovo, eventuale equipaggiamento richiesto e altre istruzioni utili).
                    </p>
                    <p>
                        Nel caso di prenotazioni effettuate 48h prima della data desiderata di svolgimento dell’attività, il
                        Partner confermerà la richiesta di prenotazione e contatterà l’utente entro 24h dall’orario di inizio
                        dell’attività.
                    </p>
                    <p>
                        La mancata conferma entro tali termini può comportare la sospensione o cessazione della
                        collaborazione tra il Partner fornitore e TicinoWild.
                    </p>
                    <p>
                        Il Fornitore esterno si assume piena responsabilità per prenotazioni non processate o non confermate
                        a causa di ritardi da parte sua.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">8. Cancellazioni e Rimborsi</h4>
                    <p>
                        I Partner fornitori stabiliscono le proprie politiche di cancellazione e rimborso, che devono essere
                        chiaramente comunicate e disponibili per gli utenti al momento della prenotazione. L’utente è tenuto a
                        prendere visione di tali termini al momento della prenotazione. In caso di necessità, l’utente può
                        contattare direttamente il fornitore per ulteriori chiarimenti sui termini applicabili.
                    </p>
                    <p>
                        In caso di annullamento di un'attività, si applicano le condizioni di cancellazione stabilite dal Partner
                        per quella specifica attività. Qualora tali condizioni prevedano un rimborso (ad esempio per
                        cancellazioni effettuate da parte del Partner stesso), il Partner è tenuto ad informare tempestivamente
                        TicinoWild, inviando una comunicazione all’indirizzo prenotazioni@ticinowild.ch entro 30 giorni
                        dall’annullamento. Il messaggio deve includere il numero di pagamento relativo all’attività annullata
                        (disponibile nell’e-mail di conferma di pagamento da parte dell’utente e denominato “ID pagamento”).
                    </p>
                    <p>
                        TicinoWild provvederà quindi a rimborsare l’utente. Si prega di notare che in assenza di notifica del
                        numero di pagamento non sarà possibile effettuare il rimborso.
                    </p>
                    <p>
                        Poiché il Partner fornitore riceve l’accredito dell’85% del prezzo dell’attività al momento della
                        prenotazione, tale importo verrà automaticamente detratto dalle prenotazioni future per coprire la
                        quota di rimborso dovuta. Il conto Stripe del Partner andrà quindi temporaneamente in negativo fino a
                        compensare l’importo rimborsato.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">9. Svolgimento dell’Attività / Responsabilità del Partner</h4>
                    <p>
                        L'attività prenotata avrà luogo nel giorno e all'orario prenotati dall’utente e confermati dal Fornitore
                        esterno. L’utente dovrà autenticarsi presso il Partner presentando la conferma d'ordine.
                    </p>
                    <p>
                        TicinoWild funge esclusivamente da intermediario tra l’utente della sua piattaforma e il Partner
                        fornitore. Durante lo svolgimento dell’attività vigono le norme e le condizioni del Partner fornitore.
                        Durante lo svolgimento delle attività, il Partner è responsabile per la sicurezza e la qualità
                        dell’esperienza offerta. Il Partner fornitore accetta che i partecipanti siano tenuti a rispettare tutte le
                        norme e le istruzioni specifiche per l’attività. TicinoWild declina ogni responsabilità per eventuali
                        incidenti, danni o perdite subite dai clienti durante le attività prenotate. Qualsiasi responsabilità
                        derivante dallo svolgimento dell’attività è a carico del Partner, il quale è tenuto a disporre di tutte le
                        assicurazioni necessarie e a conformarsi alle normative vigenti in materia di sicurezza e responsabilità
                        civile.
                    </p>
                    <p>
                        Quando un utente della piattaforma TicinoWild effettua una prenotazione per un’attività offerta dal
                        Partner, il contratto relativo alla prenotazione viene stipulato sempre esclusivamente tra il Partner e
                        l'utente in questione.
                    </p>
                    <p>
                        Il Partner si assume totalmente il rischio e la responsabilità delle interazioni tra sé e gli utenti della
                        piattaforma TicinoWild. TicinoWild declina ogni responsabilità in merito ad azioni, omissioni, errori,
                        rappresentazioni, garanzie, violazioni o negligenza da parte del Partner e in merito a lesioni personali,
                        decesso, danni di proprietà o altri danni o spese risultanti dalle interazioni dell'utente con il Fornitori di
                        terze parti.
                    </p>
                    <p>
                        I diritti di ricorso in relazione a un contratto tra il Partner e un utente della piattaforma TicinoWild (ad
                        esempio, in relazione a rimborsi e cancellazioni) saranno da intendersi tra il Partner e l’utente in
                        questione, come stabilito nel contratto con quest'ultimo.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">10. Obblighi del Partner fornitore</h4>
                    <h4 className="text-[#225424]">11.1. Potere di disposizione sul prodotto offerto</h4>
                    <p>
                        Il Partner fornitore ha il diritto di offrire esclusivamente attività che sono gestite direttamente da lui o
                        da collaboratori dell’impresa che rappresenta.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">11.2. Informazioni veritiere e complete sull'attività proposta</h4>
                    <p>
                        Il Fornitore esterno è tenuto a fornire informazioni veritiere, chiare e accurate sull’attività offerta,
                        evitando qualsiasi carattere fuorviante o scorretto, e a mantenerle aggiornate, rimuovendo quelle non
                        più disponibili. Deve inoltre garantire una descrizione completa delle modalità di svolgimento
                        dell’attività, dei requisiti richiesti, delle competenze necessarie per la partecipazione e di eventuali
                        materiali tecnici o abbigliamento richiesti. Deve, infine, fornire termini e condizioni chiari e accurati.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">11.3. Diritti d’autore</h4>
                    <p>
                        Il Partner conferma di fornire a TicinoWild solo immagini e contenuti non protetti da diritti d’autore o
                        per le quali ha ottenuto la necessaria autorizzazione da chi detiene i diritti d’autore. Inviando immagini
                        e contenuti a TicinoWild, il Partner autorizza TicinoWild a pubblicarli sul proprio sito web e a utilizzarli
                        sui propri canali per scopi promozionali, qualora lo desideri.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">11.4. Esenzione</h4>
                    <p>
                        Se terzi rivendicano diritti nei confronti di TicinoWild per violazione dei loro diritti, a causa di attività o
                        contenuti pubblicati dal Partner fornitore o per un uso diverso dal sito di TicinoWild da parte del
                        Partner fornitore, il Partner in questione manleva TicinoWild da tutte le pretese e s’impegna ad
                        assumere anche le spese di difesa legale di TicinoWild (comprese le spese processuali e legali).
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">12. Contenuti pubblicati; schede di attività e categorie</h4>
                    <p>
                        I partner forniscono a TicinoWild le informazioni richieste relative alle attività da loro offerte,
                        assicurandosi che queste siano accurate e complete. TicinoWild si riserva tuttavia il diritto di
                        apportare modifiche a tali informazioni prima della pubblicazione, in particolare per quanto riguarda
                        la forma e la lingua, al fine di garantire uno standard di comunicazione coerente e professionale.
                        TicinoWild può inoltre arricchire se necessario le informazioni fornite dai partner, per rendere le
                        schede di attività maggiormente chiare, comprensibili e complete. TicinoWild si impegna a non
                        alterare il senso o l’intenzione originaria delle informazioni comunicate dai partner e a mantenerle
                        fedeli al messaggio da loro voluto. In caso di informazioni errate o incomplete è possibile contattare in
                        ogni momento TicinoWild e chiederne la modifica, scrivendo a info@ticinowild.ch.
                    </p>
                    <p>
                        I partner si impegnano a verificare regolarmente le informazioni delle attività da loro inserite sulla
                        piattaforma e a notificare tempestivamente eventuali modifiche o la sospensione di attività non più
                        disponibili, per garantire che i contenuti pubblicati siano sempre aggiornati e affidabili per gli utenti.
                    </p>
                    <p>
                        TicinoWild è autorizzata a cancellare singole schede di attività, materiale testuale e fotografico sul sito
                        web in qualsiasi momento senza ulteriori richieste e senza indicarne i motivi. Ciò vale in particolare
                        per le attività inserite che risultano non più esistenti o disponibili, o con testi o immagini che
                        potrebbero violare i diritti di terzi. Da tali cancellazioni non è possibile avanzare alcuna pretesa nei
                        confronti di TicinoWild.
                    </p>
                    <p>
                        Inoltre, TicinoWild ha il diritto, in qualsiasi momento senza preavviso e senza giustificazione, di
                        rinominare, dividere, combinare, annullare o introdurre nuove categorie di attività e di spostare le
                        attuali schede di attività in un'altra categoria o cancellarle di conseguenza.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13. Utilizzo dei Dati dell’Utente</h4>
                    <p>
                        TicinoWild trasmetterà ai Partner fornitori i dati personali e di contatto dell’utente della sua
                        piattaforma necessari per l’organizzazione e la realizzazione dell’attività prenotata. I Partner fornitori di
                        TicinoWild sono tenuti a utilizzare questi dati esclusivamente ai fini di conferma ed organizzazione
                        dell’attività prenotata. Qualsiasi altro uso dei dati personali è ritenuto improprio e costituisce una
                        violazione degli obblighi contrattuali tra TicinoWild e i suoi Fornitori partner.
                    </p>
                    <p>
                        Il Fornitore è inoltre tenuto a cancellare i dati personali e di contatto dell’utente entro 2 settimane dal
                        termine dell’attività.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">14. Divieto di Contatto Diretto</h4>
                    <p>
                        I Partner fornitori confermano di non contattare privatamente gli utenti per vendere loro attività al di
                        fuori della piattaforma di TicinoWild. Qualsiasi violazione di questa disposizione comporterà la
                        possibilità di sospensione o cessazione della collaborazione con TicinoWild.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">15. Indennizzo</h4>
                    <p>
                        I fornitori accettano di manlevare, difendere e tenere indenne TicinoWild da qualsiasi reclamo,
                        responsabilità, danno, perdita o spesa derivante da inadempienze contrattuali, negligenza, omissioni
                        o violazioni commesse durante la prestazione del servizio. TicinoWild non è responsabile per eventuali
                        danni (compensativi, diretti, indiretti, consequenziali o di altra natura) di qualsiasi tipo, lesioni,
                        perdite, infortuni o decessi subiti dai partecipanti durante la/le attività.
                    </p>
                </div>


                <div>
                    <h4 className="text-[#225424]">16. Recesso</h4>
                    <p>
                        Il contratto quadro rimane valido fino a quando il Partner fornitore non decide di disdirlo o fino a
                        quando TicinoWild non lo annulla.
                    </p>
                    <p>
                        Il Partner può interrompere la collaborazione con TicinoWild in qualsiasi momento con un preavviso
                        scritto di 30 giorni, da inviare a info@ticinowild.ch.
                        Eventuali prenotazioni confermate prima del recesso dovranno essere onorate, a meno che il Fornitore
                        esterno non concordi diversamente con l’utente che ha prenotato l’attività. In questi casi il contratto
                        quadro resta valido fino al termine delle attività confermate.
                    </p>
                    <p>
                        TicinoWild può risolvere il contratto quadro in via straordinaria e senza preavviso se il Partner ha
                        materialmente violato gli obblighi previsti dalle presenti CGF , se il Partner ha violato le leggi, i
                        regolamenti o i diritti di terzi applicabili, o se tale azione è necessaria e appropriata per proteggere la
                        sicurezza o la proprietà di terzi.
                    </p>
                    <p>
                        Tranne nel caso di violazioni gravi, TicinoWild, per quanto possibile e opportuno, annuncerà un
                        provvedimento e darà al Partner la possibilità di porre rimedio alla violazione.
                    </p>
                    <p>
                        Dopo l'annullamento del contratto quadro, non sussiste alcun diritto al ripristino della collaborazione
                        tra TicinoWild e il Partner fornitore.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">17. Protezione dei dati</h4>
                    <h4 className="text-[#225424]">17.1. Dati raccolti</h4>
                    <p>
                        TicinoWild assegna grande importanza alla protezione dei dati personali e raccoglie dati personali solo
                        quando necessario per fornire i propri servizi.
                    </p>
                    <p>
                        Per pubblicare un’attività sul sito web di TicinoWild e registrarsi come Partner, sono richiesti alcuni
                        dati personali e di contatto, come il nome dell’impresa o del fornitore, il numero di telefono e
                        l’indirizzo e-mail.
                    </p>
                    <p>
                        Inserendo i propri dati personali o quelli dell’impresa rappresentata, il Partner autorizza
                        automaticamente TicinoWild a condividere tali informazioni con gli utenti in caso di prenotazione di
                        un’attività offerta da sé stesso o dall’impresa che rappresenta.
                    </p>
                    <p>
                        I dati di contatto forniti dai Partner sono fondamentali per garantire il corretto svolgimento dell’attività
                        prenotata, consentendo all’utente di contattare il Partner in caso di necessità.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">17.2. Trasmissione di e-mail</h4>
                    <p>
                        Registrandosi come Partner sul sito web di TicinoWild, il Partner accetta di ricevere via e-mail le
                        richieste di prenotazione per le attività da lui pubblicate, oltre ad altre comunicazione ritenute rilevanti
                        per lui (come ad esempio modifiche alle CGF).
                    </p>
                    <p>
                        È importante notare che, di norma, la trasmissione delle e-mail avviene in forma non codificata,
                        comportando il rischio che i dati possano essere intercettati e letti da terzi.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">17.3. Conservazione dei dati</h4>
                    <p>
                        TicinoWild conserva i dati personali solo per il tempo necessario a soddisfare le finalità per cui sono
                        stati raccolti. TicinoWild adotta misure tecniche e organizzative adeguate per garantire la sicurezza dei
                        dati e prevenirne l’accesso non autorizzato.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">17.4. Cancellazione dei dati / Diritti</h4>
                    <p>
                        I Partner hanno il diritto di chiedere la rettifica o la cancellazione dei propri dati personali o di quelli
                        dell’impresa che rappresentano in qualsiasi momento. Per esercitare questi diritti, possono contattare
                        TicinoWild all’indirizzo e-mail seguente: info@ticinowild.ch
                    </p>
                    <p>
                        Si prega di notare che la cancellazione di questi dati ha come conseguenza l’interruzione della
                        collaborazione tra TicinoWild e il Partner e la cancellazione di tutte le attività inserite dal Partner sulla
                        piattaforma di TicinoWild.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">17.5. Obblighi del Partner</h4>
                    <p>
                        In qualità di fornitore di attività, il Partner si impegna a rispettare tutte le leggi e i regolamenti
                        applicabili alla raccolta, al trattamento, all'utilizzo e alla sicurezza dei dati personali, inclusa la Legge
                        federale sulla protezione dei dati (LPD). Il Partner garantirà l'adozione di sistemi e controlli di sicurezza
                        adeguati a prevenire la distruzione accidentale o illecita, la perdita, l'alterazione, la divulgazione non
                        autorizzata o l'accesso a dati personali (come definiti dalla LPD) trasferiti, conservati o altrimenti
                        elaborati dal Fornitore esterno ("Incidente di sicurezza") in relazione al presente accordo.
                    </p>
                    <p>
                        Qualora il Partner sospettasse o avesse motivo di ritenere che si sia verificato un Incidente di
                        sicurezza, dovrà informare immediatamente TicinoWild per iscritto e collaborare pienamente con
                        TicinoWild per indagare, risolvere e mitigare gli effetti dell'Incidente di sicurezza. Il Partner si impegna,
                        salvo un eventuale obbligo legale, a non informare alcuna persona fisica, utente, autorità di
                        regolamentazione o di controllo riguardo a un Incidente di sicurezza senza il consenso di TicinoWild.
                        Inoltre, il Partner si impegna a fornire qualsiasi assistenza ragionevolmente richiesta da TicinoWild al
                        fine di adempiere ai suoi obblighi ai sensi della Legge sulla protezione dei dati.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">18. Modifiche delle condizioni generali</h4>
                    <p>
                        TicinoWild si riserva il diritto di modificare le CGF in qualsiasi momento. Eventuali modifiche saranno
                        comunicate ai Partner, i quali avranno la possibilità di accettarle o recedere dalla collaborazione
                        prima dell'entrata in vigore delle modifiche e degli adeguamenti. Nel caso in cui il Partner non receda
                        dall’accordo prima della data di entrata in vigore delle nuove CGF e continui a utilizzare la piattaforma
                        per offrire i propri servizi, ciò costituirà tacita accettazione delle suddette CGF. Le nuove CGF
                        sostituiscono quindi integralmente le CGF precedentemente in vigore.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">19. Clausola di salvaguardia</h4>
                    <p>
                        Qualora singole disposizioni delle presenti CGF siano del tutto o in parte nulle e/o inefficaci, la validità
                        e/o l'efficacia delle restanti disposizioni o parti di tali disposizioni rimane inalterata. Le disposizioni
                        non valide e/o inefficaci devono essere sostituite da disposizioni che si avvicinino in modo
                        giuridicamente efficace il più possibile al significato e allo scopo delle disposizioni non valide e/o
                        inefficaci. Lo stesso vale per le eventuali lacune del regolamento.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">20. Foro competente e diritto applicabile</h4>
                    <p>
                        Fatte salve altre disposizioni di legge, gli accordi relativi alle presenti CGF sono disciplinati
                        esclusivamente dal diritto svizzero. Il foro competente per tutte le controversie che sorgono in
                        relazione al presente contratto è Lugano.
                    </p>
                </div>

                <p>
                    Per facilitare la lettura del presente documento, il genere maschile è usato per designare persone e
                    funzioni indipendentemente dal genere.
                </p>
                <p>
                    ©2024 TicinoWild. Tutti i diritti riservati.
                </p>
                <p>
                    Ultimo aggiornamento: 12.12.2024
                </p>

            </div>
        </PageContainer>
    )
}

export default PartnerUserTermsAndConditions